export enum UserType {
    engineer = 'Engineer',
    reseller = 'Reseller',
    endUserAdmin = 'EndUserAdmin',
    endUser = 'EndUser',
    admin = 'admin',
}
